import gql from 'graphql-tag';

export const CREATE_DSRC_ASSESSMENT = gql`
  mutation ($applicationId: ID!) {
    createDSRCAssessment(applicationId: $applicationId) {
      valid
    }
  }
`;
